/*
 * Title:  Rewards/EarnTabContent.tsx
 * Author: Chris Rosa
 * Email: chris@encore.fans
 * Description: Earn Content page content listing, click on list to expand.
 * Date: 30 Jun 2022
 * Copyright (c) Encore, 2022
 * Version:0.1.0
 */

import { useState, useRef, Fragment } from "react";
import check from "@assets/check.png";
import Icon from "@components/Icon";
import { numberFormat, makeSecureUrl, routerLink, handleTitle, handleDescription } from "@helpers/common";
import { Dialog, Transition } from "@headlessui/react";
import { toast } from "react-toastify";
import copy_check from "@assets/copy_check.png";
import usta from "@assets/usta-logo.png";
import { useNavigate, Link } from "react-router-dom";
import LimitCounter from "./LimitCounter";
import QrPopUp from "@components/QrPopUp";
import moment from "moment";
import { useSelector } from "react-redux";
import meta from "@common/meta.json";
import FollowTimer from "@components/FollowTimer";
import { calculateRedumptionTiime } from "@helpers/common";
import service from "@services/callback-service";
import Loader from "@components/Loader";
import {
  handleConnectButton,
  handleFanSocialAuth,
  fanSocialTouchpoints,
} from "@helpers/socialAuth";
import SubscriptionEmail from "@components/VerificationAction/SubscriptionEmail";
import SubscriptionSms from "@components/VerificationAction/SubscriptionSms";
import common from "@common/common";
import NotificationService from "@services/notification-service";
import Emitter from "@services/emitter-service";
import TextCompleted from "@components/EnterToWin/TextCompleted";
import Mixpanel from "@services/mixpanel-events";

type Props = {
  item: {
    id: string;
    label: string;
    action: string;
    dynamic: boolean;
    points: number;
  }[];
  redeemed: Boolean;
  touchpoint: {
    id: string;
    label: string;
    touchpoint: string;
    description: string;
    image: string;
  };
};

const EarnContentItem: React.FC<Props | any> = (props) => {
  const [toggleHeight, setToggleHeight] = useState(false);
  const [touchpoint, setTouchpoint] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isShow, setIsShow] = useState(false);
  const [isAuthorize, setIsAuthorize] = useState(false);
  const [isAuthorizeLoader, setIsAuthorizeLoader] = useState(false);
  const typeformRef = useRef(null);
  const inputFileRef = useRef(null);
  const data = useSelector((state: any) =>
  Object.assign({}, state.user?.user?.user)
);
  const socialConnection = useSelector((state: any) => state?.score?.data?.socials || {});
  const creatorData = useSelector((state: any) => state?.creator);
  const programUrl =
    creatorData?.creator?.username + "/" + creatorData?.program?.name;

  const toggleHandler = () => {
    if(disabled){
      return;
    }
    if (!toggleHeight) {
      Mixpanel.send(`Action Tapped -- ${props?.item?.title}`, {action_name: props?.item?.title})
    }
    if(props.item?.action == "connect"){

      if (isRedirect) {
        handleFanSocialAuth(
          socialType.toLowerCase(),
          props.item?.touchpoint?.id,
          props.item
        );
      } else {
        setIsAuthorize(true)
       
      }

      return;
    }
    setToggleHeight(!toggleHeight);
  };

  const viewQrcode = (actionItem) => {
    if (props.item?.touchpoint?.name == "qrCode") {
      setTouchpoint(actionItem);
    }
  };

  const viewSurvey = (actionItem) => {
    if (
      props?.item?.touchpoint?.name == "featured" &&
      props.item?.action == "survey"
    ) {
      setTouchpoint(actionItem);
    }
  };

  const isMobile = () => {
    var userAgent = navigator.userAgent;

    if (/windows phone/i.test(userAgent)) {
      return true;
    }
    if (/android/i.test(userAgent)) {
      return true;
    }
    if (/iPad|iPhone|iPod/.test(userAgent)) {
      return true;
    }

    return false;
  }; 

  const openTypeForm = () => {
      const data = {
        isOpen : true,
        data : `https://form.typeform.com/to/${props.item?.config?.typeformId}?typeform-source=${process.env.REACT_APP_BASE_URL}#fanid=${props.user?.user?.id}&programid=${creatorData?.program?.id}&actionid=${props.item?.id}`
      }
      Emitter.emit('typeFormPopup',data);
  };

  const navigateToLink = () => {
    // let link = `${routerLink(programUrl)}/scanner/event?id=${
    //   props.item?.id
    // }&seed=${props.item?.config?.seed}&eventId=${props.item?.config?.eventId}`;
    // if (props.item?.config?.redirectUrl) {
    //   link += `&redirectUrl=${props.item?.config?.redirectUrl}`;
    // }
    let link = props.item?.config?.eventUrl;
    if (props.item?.touchpoint?.name == "typeform") {
      window.open(props.item?.config?.url, "_blank");
    } else {
      if (props.item?.config?.redirectUrl) {
        window.open(link, "_blank");
        setTimeout(() => {
          //callbackService.fetchScoreTouchpoint()
        }, 3000);
      } else {
        if (isMobile()) {
          inputFileRef?.current?.click();
        }
      }
    }
  };

  const authorize = async () => {
    const data  = {
      id: socialConnection?.[socialType.toLowerCase()],
      programId: creatorData?.program?.id,
      fanId: props.user?.user?.id,
      actionId: props.item?.id,
      tpId: props.item?.touchpoint?.id,
      pointsEarned: props.item?.points,
      details: {}
    }
    setIsAuthorizeLoader(true)
    await props.authorize(data);
    setIsAuthorizeLoader(false)
    setIsAuthorize(false)
  }

  const handleSubscribe = async (field, value) => {
    const data  = {
      programId: creatorData?.program?.id,
      fanId: props.user?.user?.id,
      actionId: props.item?.id,
      tpId: props.item?.touchpoint?.id,
      pointsEarned: props.item?.points,
      details: {
        [field]: value
      }
    }
    setIsAuthorizeLoader(true)
    const json = await props.authorize(data);
    if(json?.status !== 201 && json?.status !== 200){
      Mixpanel.send("Error Recieved", {page_path: '/earn', error_message: json?.data?.message || "An error occurred"})
      NotificationService.error(json?.data?.message || "An error occurred")
    }
    setIsAuthorizeLoader(false)
  }

  const redemptionInfo = props.redemptionInfo || {};

  const isAdditionalStep = meta.includes(creatorData?.creator?.username);

  const limit = props.item?.config?.limit || -1;

  const lock =
    (props.item?.config?.limit || -1) ==
    (props.item?.shares?.fanEngagement || 0);
  const config = calculateRedumptionTiime(
    props.item?.config,
    props.item?.shares?.lastEngagement,
    props.item?.shares?.fanEngagement,
    props.item?.totalEngagements,
    -1
  );
  // const redeemed = config?.isRedeemed;
  const redeemed = config?.isDisabled;
  const disabled = config?.isDisabled;
  const isShowingRedemption =
    (props.item?.config?.limit < 0 || props.item?.config?.limit > 1) &&
    props.item?.shares?.fanEngagement > 0;
  const fanEngagement = `${
    props.item.action == "refer"
      ? `${props.item?.shares?.fanEngagement} friends joined`
      : `completed ${props.item?.shares?.fanEngagement}x`
  }`;

  const socialType = (props.item.type || "").slice(
    (props.item.type || "").indexOf(":") + 1
  );
  let isRedirect = true;
  const connect =
    props.item?.config?.limit == props.item?.shares?.fanEngagement;

    const isCardDisabled = (props.item.isDisabled)?true:props.item?.socialAction?.id && props.item?.action!="connect";

  let description = props.item.description;
  let title = (props.item.title || "").replace("{hashtag}", (props.item?.config?.hashtag || ""));

  if(disabled && props.item.action=="email" || props.item.action=="sms"){
    description = "";
  }

  if(disabled && props.item.action=="connect"){
    if(props.item.type.includes("tiktok")){
      if(!!socialConnection?.tiktokUsername){
        description = `Connected as <span class="font-semibold text-[15px]">${(socialConnection?.tiktokUsername || "")}</span>`;
      }
      
    }
    if(props.item.type.includes("youtube")){
      if(!!socialConnection?.youtubeUsername){
        description = `Connected as <span class="font-semibold text-[15px]">${(socialConnection?.youtubeUsername || "")}</span>`;
      }
      
    }
    if(props.item.type.includes("instagram")){
      if(!!socialConnection?.instagramUsername){
        description = `Connected as <span class="font-semibold text-[15px]">${(socialConnection?.instagramUsername || "")}</span>`;
      }
      
    }
    if(props.item.type.includes("facebook")){
      if(!!socialConnection?.facebookUsername){
        description = `Connected as <span class="font-semibold text-[15px]">${(socialConnection?.facebookUsername || "")}</span>`;
      }
      
    }
    if(props.item.type.includes("twitter")){
      if(!!socialConnection?.twitterUsername ){
        description = `Connected as <span class="font-semibold text-[15px]">${(socialConnection?.twitterUsername || "")}</span>`;
      }
      
    }
  } else if(!disabled && props.item.action=="connect"){
    description = "";
  }
  if(!disabled && props.item.action=="connect"){
    if(props.item.type.includes("tiktok") &&  socialConnection?.tiktok){
      title = `Authorize TikTok`;
      description = `Connected as <span class="font-semibold text-[15px]">${(socialConnection?.tiktokUsername || "")}</span>`;
      isRedirect = false;
    }
    if(props.item.type.includes("youtube") && socialConnection?.youtube){
      title = `Authorize Youtube`;
      description = `Connected as <span class="font-semibold text-[15px]">${(socialConnection?.youtubeUsername || "")}</span>`;
      isRedirect = false;
    }
    if(props.item.type.includes("instagram") && socialConnection?.instagram){
      title = `Authorize Instagram`;
      description = `Connected as <span class="font-semibold text-[15px]">${(socialConnection?.instagramUsername || "")}</span>`;
      isRedirect = false;
    }
    if(props.item.type.includes("facebook") && socialConnection?.facebook){
      title = `Authorize Facebook`;
      description = `Connected as <span class="font-semibold text-[15px]">${(socialConnection?.facebookUsername || "")}</span>`;
      isRedirect = false;
    }
    if(props.item.type.includes("twitter") && socialConnection?.twitter){
      title = `Authorize X`;
      description = `Connected as <span class="font-semibold text-[15px]">${(socialConnection?.twitterUsername || "")}</span>`;
      isRedirect = false;
    }
  }
  if(isCardDisabled && props.item.type.includes("socialMedia")){
    if(props.item.type.includes("tiktok") && socialConnection?.tiktok){
      description = `Authorize TikTok to unlock`;
    }
    if(props.item.type.includes("youtube") && socialConnection?.youtube){
      description = `Authorize Youtube to unlock`;
    }
    if(props.item.type.includes("instagram") && socialConnection?.instagram){
      description = `Authorize Instagram to unlock`;
    }
    if(props.item.type.includes("facebook") && socialConnection?.facebook){
      description = `Authorize Facebook to unlock`;
    }
    if(props.item.type.includes("twitter") &&  socialConnection?.twitter){
      description = `Authorize X to unlock`;
    }
  }

  title = handleTitle(props?.item, title);
  description = handleDescription(props?.item, description);


  return (
    <div 
    data-testid={`card-${props.item?.action}`}
    className="relative bg-tile">
      {disabled && (
        <div data-testid={`check-${props.item?.action}`} className="bg-green rounded-full p-[4px] h-5 w-5 flex items-center justify-center z-10 absolute -left-1 -top-1 overflow-hidden">
          <img
            src={check}
            alt="Check"
            className="object-contain w-full h-full"
          />
        </div>
      )}
      <div
        onClick={(e) => {
          if (e.defaultPrevented) return;
          toggleHandler();
        }}
        className={`${
          toggleHeight
            ? "max-h-[100vh] transition-[max-height] ease-in-out duration-1000"
            : "lg:max-h-[161px] max-h-[151px]"
        } bg-tile p-[20px] transition-all duration-700 ease-in-out  rounded-[10px] mt-5 relative cursor-pointer overflow-hidden`}
        key={props.item?.id}
      >
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-[8px]">
            {redeemed ? (
              <div className="bg-tile-form opacity-50 p-[8px] rounded-full flex items-center justify-center">
                {props.item?.rate > 0 ? (
                  <p className="bg-body opacity-50 lg:text-[14px] text-[12px] uppercase font-normal tracking-wider">
                    {numberFormat(props.item.rate)} Points PER $1
                  </p>
                ) : (
                  <p className="bg-body opacity-50 lg:text-[14px] text-[12px] uppercase font-semibold tracking-wider tile-inlay-primary">
                    {numberFormat(props.item.points)} Points
                  </p>
                )}
              </div>
            ) : (
              <div className="bg-body p-[8px] rounded-full flex items-center justify-center">
                {props.item?.rate > 0 ? (
                  <p className="green lg:text-[14px] text-[12px] uppercase font-semibold tracking-wider">
                    + {numberFormat(props.item.rate)} POINTS PER $1
                  </p>
                ) : (
                  <p className="green lg:text-[14px] text-[12px] uppercase font-semibold tracking-wider">
                    + {numberFormat(props.item.points)} POINTS
                  </p>
                )}
              </div>
            )}
            {props?.username == "orlandomagic" &&
            props.item?.touchpoint?.name == "qrcode" ? (
              <LimitCounter counter={1} disabled={lock} />
            ) : (
              <>
                {"limit" in props.item?.config && (
                  <LimitCounter counter={limit} disabled={lock} />
                )}
              </>
            )}
          </div>
          <div className="-mt-1">
            {props.item?.config?.url &&
            props?.item?.touchpoint?.name != "qrcode" &&
            props?.item?.touchpoint?.name != "typeform" &&
            props.item?.touchpoint?.name !== "play" ? (
              <a
                rel="noreferrer"
                // {...(!props.item?.socialAction?.id && {
                //   href: makeSecureUrl(props.item?.config?.url),
                // })}
                href={makeSecureUrl(props.item?.config?.url)}
                // onClick={() => {
                //   if (props.item?.socialAction?.id) {
                //     setIsShow(true);
                //   }
                // }}
                target={props.item?.config?.url ? "_blank" : ""}
              >
                <Icon icon={socialType} item={props.item} />
              </a>
            ) : props.item?.config?.url &&
              props?.item?.touchpoint?.name != "typeform" &&
              props.item?.touchpoint?.name !== "play" ? (
              <a
                rel="noreferrer"
                // {...(!props.item?.socialAction?.id && {
                //   href: makeSecureUrl(props.item?.config?.url),
                // })}
                href={makeSecureUrl(props.item?.config?.url)}
                // onClick={() => {
                //   if (props.item?.socialAction?.id) {
                //     setIsShow(true);
                //   }
                // }}
                target={props.item?.config?.url ? "_blank" : ""}
              >
                <Icon icon={socialType} item={props.item} />
              </a>
            ) : (
              <div onClick={() => viewQrcode(props.item)}>
                {isAdditionalStep &&
                (props.item?.touchpoint?.name == "featured" ||
                  props.item?.touchpoint?.name == "play") ? (
                  <img
                    alt={"logo"}
                    src={usta}
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null;
                      currentTarget.src = usta;
                    }}
                    className="w-10 h-10 rounded-full"
                  />
                ) : (
                  <Icon icon={socialType} item={props.item} />
                )}
              </div>
            )}
          </div>
        </div>
        <h4 data-testid={`title-${props.item?.action}`} className="font-semibold tile-inlay-primary lg:text-[20px] text-[16px] mt-[15px]">
          {props.item?.title ? props.item?.title : "No Title"}
        </h4>
        {/* expanded  */}
        <p data-testid={`desc-${props.item?.action}`}
          className={`${
            toggleHeight ? null : "truncate"
          } tile-inlay-primary text-[16px] font-normal tracking-wider mt-[15px] description_link`}
          dangerouslySetInnerHTML={{
            __html: props.item.description || "<br/>",
          }}
        ></p>
        {props.item?.action == "refer" && !disabled && (
          <>
            <div className="divide-y h-[1px] w-full bg-tile-form bg-gray-600 my-[20px] bg-opacity-40" />
            <div data-testid={`field-${props.item?.action}`} className="mt-5">
              <div className="flex items-center gap-x-3 bg-tile-form rounded-xl">
                <>
                  <div data-testid="copybtn"  className="h-[35px] opacity-50  px-3 min-w-[215px] grow rounded-full flex items-center justify-center cursor-text">
                    <p className="tile-inlay-primary text-[15px] font-normal truncate ">
                      {`${routerLink(programUrl)}/?invite=${
                        props.user?.user?.id
                      }&a=${props.item.id}`}
                    </p>
                  </div>
                  <div
                    onClick={() => {
                      navigator.clipboard.writeText(
                        `${routerLink(programUrl)}/?invite=${
                          props.user?.user?.id
                        }&a=${props.item?.id}`
                      );
                      toast.success(
                        <div className="flex items-center gap-x-3 text-[black] text-[14px]">
                          <img
                            alt="logo"
                            src={copy_check}
                            className="h-[20px] w-[20px] object-contain"
                          />
                          Link copied!
                        </div>,
                        {
                          icon: false,
                          position: "bottom-center",
                          autoClose: 5000,
                          hideProgressBar: false,
                          closeOnClick: true,
                          pauseOnHover: true,
                          draggable: true,
                          // progress: undefined,
                          theme: "light",
                        }
                      );
                    }}
                    className="h-[35px] w-[35px] flex-shrink-0 rounded-full flex items-center justify-center"
                  >
                    <svg
                      className="h-5 w-5 copy-icon-color"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      {" "}
                      <rect
                        x="9"
                        y="9"
                        width="13"
                        height="13"
                        rx="2"
                        ry="2"
                      />{" "}
                      <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
                    </svg>
                  </div>
                </>

                {/* <div className="h-[35px] w-[35px] bg-[#FCC3A7] flex-shrink-0 rounded-full flex items-center justify-center">
                  <img
                    src={share}
                    className="object-contain w-[12px] h-[14px]"
                  />
                </div> */}
              </div>
            </div>
          </>
        )}
        {!props.item?.dynamic && (
          <>
            {props.item?.config?.redirectUrl ? (
              <>
                <div className="divide-y h-[1px] w-full bg-gray-600 my-[20px] bg-opacity-40" />
                <div className="mt-5">
                  <div className="flex items-center gap-x-3">
                    <div className="justify-center flex w-full">
                      <button
                      data-testid={`btnqr-${props.item?.action}`}
                        disabled={disabled}
                        onClick={navigateToLink}
                        className={`w-full h-[42px] max-w-[300px] ${
                          !disabled
                            ? "bg-btn border-primary btn-inlay-primary "
                            : "bg-[#616161] text-white"
                        } border-black btn-inlay-primary  rounded-[50px]`}
                      >
                        <span className="text-inherit">
                          {disabled ? "complete" : "go"}
                        </span>
                      </button>
                    </div>
                  </div>
                  <>
                    {/* {!!config?.humanize &&
              
                <p className="text-[14px] leading-[14px] font-normal text-[#44CD51] text-center mt-[10px]">{`available again in ${config?.humanize}`} </p>
              } */}
                  </>
                </div>
              </>
            ) : (
              <>
                {isMobile() ||
                  ("lastRedemption" in redemptionInfo && (
                    <div className="divide-y h-[1px] w-full bg-gray-600 my-[20px] bg-opacity-40" />
                  ))}
                <div className={`mt-6`}>
                  <div className="flex items-center gap-x-3">
                    <div className="justify-center flex w-full">
                      {isMobile() &&
                        props?.item?.touchpoint?.name == "qrcode" && (
                          <button
                            disabled={disabled}
                            onClick={props.openCamera}
                            className={`w-full h-[42px] max-w-[300px] ${
                              !disabled
                                ? "bg-btn border-primary  btn-inlay-primary"
                                : "bg-[#616161] text-white"
                            } border-black btn-inlay-primary  rounded-[50px]`}
                          >
                            <span className="text-inherit">
                              {disabled ? "complete" : "scan QR code"}
                            </span>
                          </button>
                        )}
                    </div>
                  </div>

                  <>
                    {/* {!!config?.humanize &&
            
              <p className="text-[14px] leading-[14px] font-normal text-[#44CD51] text-center mt-[10px]">{`available again in ${config?.humanize}`} </p>
            } */}
                  </>
                </div>
              </>
            )}
            <input
              ref={inputFileRef}
              accept="image/*"
              id="scan-qr-code"
              className="invisible absolute"
              type="file"
              capture="environment"
            />
          </>
        )}
        {props?.item?.touchpoint?.name == "typeform" && (
          <>
            <div className="divide-y h-[1px] w-full bg-gray-600 my-[20px] bg-opacity-40" />
            <div className="mt-5">
              <div className="flex items-center gap-x-3">
                <div className="justify-center flex w-full">
                  {props.item?.id && (
                    <div data-testid={`tform-${props.item?.action}`}
                      className="w-full flex justify-center items-center max-w-[300px] h-[42px] bg-[#616161] rounded-[50px] btn-inlay-primary"
                      onClick={(e) => {
                        e.preventDefault();
                      }}
                    >
                      {!disabled ? (
                        <button
                        onClick={openTypeForm}
                          className="w-full max-w-[300px] h-[42px] bg-btn border border-primary rounded-[50px]"
                        >
                          <span className="btn-inlay-primary">
                            complete form
                          </span>
                        </button>
                      ) : (
                        <span className="btn-inlay-primary">complete form</span>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </>
        )}
        
        {props.item?.action == "email" && (
           <>
           {!disabled &&
            <SubscriptionEmail handleSubscribe={handleSubscribe} isAuthorizeLoader={isAuthorizeLoader} data={data}/>
           }
         </>
          )}

        {props?.item?.touchpoint?.name == "survey" && (
          <>
            <div className="divide-y h-[1px] w-full bg-gray-600 my-[20px] bg-opacity-40" />
            <div className="mt-5">
              <div className="flex items-center gap-x-3">
                <div className="justify-center flex w-full">
                  {props.item?.id && (
                    <button
                      disabled={redeemed}
                      className={`w-full max-w-[300px] h-[42px] ${
                        redeemed ? "bg-[#616161]" : "bg-btn"
                      }  rounded-[50px] btn-inlay-primary`}
                      onClick={(e) => {
                        e.preventDefault();
                        props.startSurvey(props.item);
                      }}
                    >
                      <span
                        className={`${
                          disabled ? "btn-inlay-primary" : "btn-inlay-primary"
                        } `}
                      >
                        complete survey
                      </span>
                    </button>
                  )}
                </div>
              </div>
            </div>
          </>
        )}
        {props.item?.config?.url &&
          props.item.action != "newFollow" &&
          props?.item?.touchpoint?.name != "typeform" &&
          props?.item?.touchpoint?.name != "qrcode" &&
          props?.item?.touchpoint?.name != "shopify" &&
          props.item?.action != "refer" && (
            <>
              <div className="divide-y h-[1px] w-full bg-gray-600 my-[20px] bg-opacity-40" />
              <div className="mt-5">
                <div className="flex items-center gap-x-3">
                  <div className="justify-center flex w-full">
                    {props.item?.id && (
                      <a data-testid={`followbtn-${props.item?.action}`}
                        rel="noreferrer"
                        // {...(!props.item?.socialAction?.id && {
                        //   href: makeSecureUrl(props.item?.config?.url),
                        // })}
                        href={makeSecureUrl(props.item?.config?.url)}
                        // onClick={() => {
                        //   if (props.item?.socialAction?.id) {
                        //     setIsShow(true);
                        //   }
                        // }}
                        target={"_blank"}
                        className="w-full max-w-[300px] h-[42px] bg-btn border border-primary rounded-[50px] zIndex-9 flex items-center justify-center"
                      >
                        <span
                          className={`${
                            disabled ? "btn-inlay-primary" : "btn-inlay-primary"
                          } `}
                        >
                          {props.item.title}
                        </span>
                      </a>
                    )}
                  </div>
                </div>
              </div>
            </>
          )}
        {props.item.action == "newFollow" && (
          <>
            <div className="divide-y h-[1px] w-full bg-gray-600 my-[20px] bg-opacity-40" />
            <div className="mt-5">
              <div className="flex items-center gap-x-3">
                <div className="justify-center flex w-full gap-2">
                  {redeemed ? (
                    <a
                      rel="noreferrer"
                      className="w-full max-w-[300px] h-[42px] bg-[#616161] rounded-[50px] flex items-center justify-center"
                    >
                      <span className="btn-inlay-primary">{props.item.title}</span>
                    </a>
                  ) : (
                    <>
                      {props.item?.pending ? (
                        <button
                          disabled
                          className="w-full max-w-[300px] h-[42px] bg-[#616161] rounded-[50px] zIndex-9 flex items-center justify-center"
                        >
                          <span className="btn-inlay-primary">
                            Pending <FollowTimer />
                          </span>
                        </button>
                      ) : (
                        <>
                          {props.connect && (
                            <button
                              onClick={() => setIsDrawerOpen(true)}
                              className="w-full max-w-[300px] h-[42px] bg-transperant border border-primary rounded-[50px] flex items-center justify-center tile-inlay-primary"
                            >
                              Confirm
                            </button>
                          )}
                          {props.item?.id && (
                            <a
                              href={makeSecureUrl(
                                props.item?.touchpoint?.url ?? props.item.url
                              )}
                              rel="noreferrer"
                              target={"_blank"}
                              className="w-full max-w-[300px] h-[42px] bg-btn border border-primary rounded-[50px] zIndex-9 flex items-center justify-center"
                            >
                              <span
                                className={`${
                                  disabled ? "btn-inlay-primary" : "btn-inlay-primary"
                                } `}
                              >
                                {props.item.title}
                              </span>
                            </a>
                          )}
                        </>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </>
        )}
        {props.item?.action == "connect" &&
          fanSocialTouchpoints().includes(socialType.toLowerCase()) && (
            <div className="justify-center w-full gap-2 hidden">
              <button
              data-testid={`connectbtn-${props.item?.action}`}
                disabled={connect}
                onClick={() => {
                  if (isRedirect) {
                    handleFanSocialAuth(
                      socialType.toLowerCase(),
                      props.item?.touchpoint?.id,
                      props.item
                    );
                  } else {
                    const data  = {
                      id: socialConnection?.[socialType.toLowerCase()],
                      programId: creatorData?.program?.id,
                      fanId: props.user?.user?.id,
                      actionId: props.item?.id,
                      tpId: props.item?.touchpoint?.id,
                      pointsEarned: props.item?.point,
                      details: {}
                    }
                    props.authorize(data);
                  }
                }}
                className={`w-full max-w-[300px] h-[42px] ${
                  connect ? "bg-[#616161]" : "bg-btn"
                }  rounded-[50px] btn-inlay-primary`}
              >
                <div
                  className={`${
                    disabled ? "btn-inlay-primary" : "btn-inlay-primary"
                  } `}
                >
                  {props.loader?.[props.item.id] ? (
                    <Loader height={30} width={30} white={true} />
                  ) : connect ? (
                    "connected"
                  ) : (
                    "connect"
                  )}
                </div>
              </button>
            </div>
          )}

        {isShowingRedemption && (
          <p className="text-[14px] leading-[14px] font-normal tile-inlay-primary opacity-80 text-center mt-[15px]">
            {fanEngagement}
          </p>
        )}
      <TextCompleted item={props.item} />
      </div>
      <QrPopUp data={touchpoint} click={viewQrcode} isFan={true} />

      <Transition appear show={isShow} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-50"
          onClose={() => {
            setIsShow(false);
          }}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-[0.85]" />
          </Transition.Child>

          <div className={`fixed inset-0`}>
            <div className="flex items-end justify-center min-h-full text-center">
              <Transition.Child
                as={Fragment}
                enter="transform transition ease-in-out duration-700"
                enterFrom="translate-y-full"
                enterTo="translate-y-0"
                leave="transform transition ease-in-out duration-700"
                leaveFrom="translate-y-0"
                leaveTo="translate-y-full"
              >
                <Dialog.Panel className="w-screen max-w-[685px] transform overflow-hidden rounded-b-none rounded-t-[40px] text-left align-middle shadow-xl transition-all bg-[#1D1D1D]">
                  <div className="relative">
                    <button
                      type="button"
                      className="text-white rounded-md outline-none hover:text-white hover:opacity-70"
                      onClick={() => setIsShow(false)}
                    >
                      <span className="sr-only">Close panel</span>
                      <div className="w-[25px] h-1 absolute mx-auto top-[10px] left-0 right-0 bottom-0 rounded-full bg-lightBlack"></div>
                      {/* <svg className="w-8 h-8 text-red-500 absolute mx-auto top-[10px] left-0 right-0 bottom-0"  width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">  <path stroke="none" d="M0 0h24v24H0z"/>  <line x1="18" y1="6" x2="6" y2="18" />  <line x1="6" y1="6" x2="18" y2="18" /></svg> */}
                    </button>
                  </div>
                  <div className="px-[30px] text-center">
                    <h3 className="tile-inlay-primary font-[550] text-[24px] leading-[31px] mt-[41px]">
                      Connect {props?.item?.touchpoint?.name}
                    </h3>
                    <p className="mt-[15px] text-[18px] font-normal leading-[22px] tile-inlay-primary">
                      Please connect your {props?.item?.touchpoint?.name} to{" "}
                      {props.item?.title}
                    </p>
                    <div className="relative">
                      <button
                        onClick={() =>
                          handleFanSocialAuth(
                            socialType.toLowerCase(),
                            props.item?.touchpoint?.id,
                            props.item?.socialAction
                          )
                        }
                        className="font-medium bg-btn rounded-full btn-inlay-primary w-full max-w-[300px] mx-auto h-[41px] flex items-center justify-center my-[50px]"
                      >
                        Connect
                      </button>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>

      <Transition appear show={isDrawerOpen} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-50"
          onClose={() => setIsDrawerOpen(false)}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-[0.85]" />
          </Transition.Child>

          <div className={`fixed inset-0`}>
            <div className="flex items-end justify-center min-h-full text-center">
              <Transition.Child
                as={Fragment}
                enter="transform transition ease-in-out duration-700"
                enterFrom="translate-y-full"
                enterTo="translate-y-0"
                leave="transform transition ease-in-out duration-700"
                leaveFrom="translate-y-0"
                leaveTo="translate-y-full"
              >
                <Dialog.Panel className="w-screen max-w-[685px] transform overflow-hidden rounded-b-none rounded-t-[40px] text-left align-middle shadow-xl transition-all bg-tile">
                  <div className="relative">
                    <button
                      type="button"
                      className="text-white rounded-md outline-none hover:text-white hover:opacity-70"
                      onClick={() => setIsDrawerOpen(false)}
                    >
                      <span className="sr-only">Close panel</span>
                      <div className="w-[25px] h-1 absolute mx-auto top-[10px] left-0 right-0 bottom-0 rounded-full bg-lightBlack"></div>
                      {/* <svg className="w-8 h-8 text-red-500 absolute mx-auto top-[10px] left-0 right-0 bottom-0"  width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">  <path stroke="none" d="M0 0h24v24H0z"/>  <line x1="18" y1="6" x2="6" y2="18" />  <line x1="6" y1="6" x2="18" y2="18" /></svg> */}
                    </button>
                  </div>
                  <div className="px-[30px] text-center">
                    <h3 className="tile-inlay-primary font-[550] text-[24px] leading-[31px] mt-[41px]">
                      We're on it!
                    </h3>
                    <p className="mt-[15px] text-[18px] font-normal leading-[22px] tile-inlay-primary">
                      You can close this window and we will keep working in the
                      background. It may take a few minutes to be rewarded.
                    </p>
                    <div className="relative">
                      <button
                        onClick={() => setIsDrawerOpen(false)}
                        className="font-medium bg-btn rounded-full btn-inlay-primary w-full max-w-[300px] mx-auto h-[41px] flex items-center justify-center my-[50px]"
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>

      {/* authorize drawer  */}
      <Transition appear show={isAuthorize} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-50"
          onClose={() => {}}
        >
          <div className={`fixed inset-0`}>
            <div className="flex items-end justify-center min-h-full text-center">
              <Transition.Child
                as={Fragment}
                enter="transform transition ease-in-out duration-700"
                enterFrom="translate-y-full"
                enterTo="translate-y-0"
                leave="transform transition ease-in-out duration-700"
                leaveFrom="translate-y-0"
                leaveTo="translate-y-full"
              >


                <Dialog.Panel className="w-screen max-w-[685px] transform overflow-hidden rounded-b-none rounded-t-[40px] text-left align-middle transition-all bg-tile" style={{boxShadow: '0px 0px 34px 0px rgba(0, 0, 0, 0.15)'}}>
                  <div className="relative">
                    <button
                      type="button"
                      onClick={() => {}}
                    >
                      <span className="sr-only">Close panel</span>
                      <div className="w-[25px] h-1 absolute mx-auto top-[10px] left-0 right-0 bottom-0 rounded-full opacity-20 bg-body"></div>
                      {/* <svg className="w-8 h-8 text-red-500 absolute mx-auto top-[10px] left-0 right-0 bottom-0"  width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">  <path stroke="none" d="M0 0h24v24H0z"/>  <line x1="18" y1="6" x2="6" y2="18" />  <line x1="6" y1="6" x2="18" y2="18" /></svg> */}
                    </button>
                  </div>
                  <div className="px-[30px] text-center">
                    <h3 className="tile-inlay-primary font-[550] text-[24px] leading-[31px] mt-[41px]">
                      Do you want to share your {socialType} data with Encore?
                    </h3>
                    <p className="mt-[15px] text-[18px] font-normal leading-[22px] tile-inlay-primary">
                      By authorizing below, you agree to share information about your account and history.
                    </p>
                    <div className="relative">
                      <button
                        onClick={authorize}
                        className="font-semibold bg-btn mt-[50px] rounded-full btn-inlay-primary w-32 mx-auto h-[41px] flex items-center justify-center"
                      >
                        {isAuthorizeLoader? <Loader height={30} width={30} white={true}  />:"authorize" }
                        
                       
                      </button>
                    </div>
                    <div className="relative">
                      <button
                        onClick={() => setIsAuthorize(false)}
                        className="font-semibold bg-black rounded-full text-white w-28 mx-auto h-[41px] flex items-center justify-center mt-[15px] mb-[50px]"
                      >
                        cancel
                      </button>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
      {props.item?.action == "sms" && (
        <div className={`${toggleHeight ? "max-h-[100vh] transition-[max-height] ease-in-out duration-1000 " : "lg:max-h-[0px] max-h-[0px] overflow-hidden"} ${isCardDisabled && "opacity-40"} pb-[5px] transition-all duration-700 ease-in-out rounded-[10px] relative cursor-pointer`}>
          {!disabled &&
            <SubscriptionSms handleSubscribe={handleSubscribe} isAuthorizeLoader={isAuthorizeLoader} data={data}/>
          }
       </div>
      )}
    </div>
  );
};

export default EarnContentItem;
